import { OnlineFunnel } from "~/constants/Funnel";

const DP_FLOW = "dp";

const getWindowLocation = (): Location => {
  return window.location;
};

export const isDynpackFromUrl = (): boolean => {
  const location = getWindowLocation();
  const searchParams = new URLSearchParams(location.search);

  const flow = searchParams.get("flowProduct");

  return flow === DP_FLOW;
};

export const getCurrentFunnel = (funnel?: OnlineFunnel): OnlineFunnel => {
  const currentFunnel = funnel ?? OnlineFunnel.FLIGHTS;

  if (isDynpackFromUrl()) {
    return OnlineFunnel.DYNPACK;
  }

  return currentFunnel;
};

export const isOriginFlow = (): boolean => {
  const location = getWindowLocation();
  const searchParams = new URLSearchParams(location.search);
  const origin = searchParams.get("origin")?.toLowerCase();

  return origin === "flow";
};
